var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubsidies(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 21C0 9.40204 9.40202 0 21 0C32.598 0 42 9.40204 42 21C42 32.598 32.598 42 21 42C9.40202 42 0 32.598 0 21Z",
    fill: "#DF9F39"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.0007 26.2501H25.5007V19.5001H26.2507C26.5969 19.5011 26.9327 19.3825 27.2014 19.1642C27.47 18.9459 27.6549 18.6414 27.7246 18.3024C27.7944 17.9633 27.7447 17.6106 27.5841 17.304C27.4234 16.9974 27.1617 16.7557 26.8432 16.6201L21.5932 14.3701C21.4054 14.2921 21.2041 14.252 21.0007 14.252C20.7974 14.252 20.596 14.2921 20.4082 14.3701L15.1582 16.6201C14.8398 16.7557 14.578 16.9974 14.4174 17.304C14.2568 17.6106 14.2071 17.9633 14.2769 18.3024C14.3466 18.6414 14.5315 18.9459 14.8001 19.1642C15.0687 19.3825 15.4046 19.5011 15.7507 19.5001H16.5007V26.2501H15.0007C14.8018 26.2501 14.6111 26.3291 14.4704 26.4697C14.3298 26.6104 14.2507 26.8012 14.2507 27.0001C14.2507 27.199 14.3298 27.3898 14.4704 27.5304C14.6111 27.6711 14.8018 27.7501 15.0007 27.7501H27.0007C27.1996 27.7501 27.3904 27.6711 27.5311 27.5304C27.6717 27.3898 27.7507 27.199 27.7507 27.0001C27.7507 26.8012 27.6717 26.6104 27.5311 26.4697C27.3904 26.3291 27.1996 26.2501 27.0007 26.2501ZM24.0007 26.2501H21.7507V19.5001H24.0007V26.2501ZM18.0007 19.5001H20.2507V26.2501H18.0007V19.5001Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_156"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubsidies);
export default __webpack_public_path__ + "static/media/subsidies.4f5643142b09eb24e0396175dd1e25d7.svg";
export { ForwardRef as ReactComponent };